/* eslint-disable no-unused-vars */
/* eslint-disable @typescript-eslint/no-unused-vars */
import { mappingApi } from "@iventis/api/src/api";
import { MapGroup } from "@iventis/domain-model/model/mapGroup";

export type MapGroupPatch = Omit<Partial<MapGroup>, "mapId"> & Pick<MapGroup, "id">;

export async function patchMapGroup(mapGroupPatch: MapGroupPatch, mapId: string) {
    await mappingApi.patch(`maps/${mapId}/groups/${mapGroupPatch.id}`, mapGroupPatch);
}

export const deleteMapGroup = (mapId: string, groupId: string) => mappingApi.delete(`/maps/${mapId}/groups/${groupId}`);
